import React from "react";
import { Link, Redirect } from "react-router-dom";
import ListErrors from "./ListErrors";
import ListSuccess from "./ListSuccess";
import agent from "../agent";
import { connect } from "react-redux";
import clsx from "clsx";
import { PasswordMeterComponent } from "../widgets";
import {
  FORCED_RESET_TOKEN,
  CLEAR_ERRORS,
  baseUrl,
} from "../constants/actionTypes";

const mapStateToProps = (state) => ({
  ...state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (email, password, new_password) => {
    dispatch({
      type: FORCED_RESET_TOKEN,
      payload: agent.Auth.forcedReset(email, password, new_password),
    });
  },
  clearErrors: () => {
    dispatch({ type: CLEAR_ERRORS });
  },
});

class ForcedPasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      new_password: "",
      confirm_password: "",
      errors: null,
    };
    this.meterRef = React.createRef();
    this.passwordMeter = React.createRef();
  }

  componentDidMount() {
    PasswordMeterComponent.bootstrap();
    this.loadMeter();
    this.props.clearErrors();
  }

  loadMeter = () => {
    this.meterRef.current = document.querySelector(
      "#kt_password_meter_control"
    );
    this.passwordMeter.current = PasswordMeterComponent.getInstance(
      this.meterRef.current
    );
  };

  submitForm = (ev) => {
    ev.preventDefault();
    let newErrors = [];

    if (this.state.email === "") {
      newErrors.push("Email is required.");
    }
    if (this.state.password === "") {
      newErrors.push("Current password is required.");
    }
    if (this.state.new_password === "") {
      newErrors.push("New password is required.");
    }
    if (this.state.new_password.length > 50) {
      newErrors.push("New password cannot exceed 50 characters.");
    }
    if (this.state.confirm_password !== this.state.new_password) {
      newErrors.push("Passwords do not match.");
    }
    if (this.passwordMeter.current) {
      if (
        this.passwordMeter.current.getScore() < 80 ||
        this.passwordMeter.current.getScore() === null ||
        this.state.new_password.length < 6
      ) {
        newErrors.push(
          "Password is not strong enough, please provide at least one uppercase, one lowercase, one number and one special symbol. Minimum 6 characters, maximum 50 characters."
        );
      }
    }

    this.setState({ errors: newErrors });
    if (newErrors.length === 0) {
      this.setState({ errors: null });
      this.props.onSubmit(
        this.state.email,
        this.state.password,
        this.state.new_password
      );
    }
  };

  render() {
    const logoUrl = baseUrl + "images/splash-logo.svg";

    // Redirect to home if forced reset was successful
    if (this.props.successMessage) {
      return <Redirect to="/" />;
    }

    return (
      <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
        <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
          <a href="#" className="mb-12">
            <img alt="Revelstoke Capital" src={logoUrl} className="h-65px" />
          </a>
          <div className="w-lg-600px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
            <form className="form w-100" onSubmit={this.submitForm} noValidate>
              <div className="text-center mb-10">
                <h1 className="text-dark mb-3">Password Reset Required</h1>
                <div className="text-gray-400 fw-bold fs-4">
                  Your password has been reset by an administrator. You must set
                  a new password to continue.
                </div>
              </div>

              {this.props.successMessage ? (
                <ListSuccess errors={this.props.successMessage} />
              ) : null}

              {this.props.errorMessage ? (
                <ListErrors errors={this.props.errorMessage} />
              ) : null}

              {this.state.errors ? (
                <ListErrors errors={this.state.errors} />
              ) : null}

              <div className="fv-row mb-7">
                <label className="form-label fw-bolder text-dark fs-6">
                  Email Address
                </label>
                <input
                  placeholder="Email Address"
                  type="email"
                  className={clsx(
                    "form-control form-control-lg form-control-solid"
                  )}
                  value={this.state.email}
                  onChange={(event) =>
                    this.setState({ email: event.target.value })
                  }
                />
              </div>

              <div className="fv-row mb-7">
                <label className="form-label fw-bolder text-dark fs-6">
                  Current Temporary Password
                </label>
                <input
                  placeholder="Current Password"
                  type="password"
                  maxLength={50}
                  className={clsx(
                    "form-control form-control-lg form-control-solid"
                  )}
                  value={this.state.password}
                  onChange={(event) =>
                    this.setState({ password: event.target.value })
                  }
                />
              </div>

              <div
                className="fv-row mb-10"
                data-kt-password-meter="true"
                ref={this.meterRef}
                id="kt_password_meter_control"
              >
                <div className="mb-1">
                  <label className="form-label fw-bolder text-dark fs-6">
                    New Password
                  </label>
                  <div className="position-relative mb-3">
                    <input
                      type="password"
                      autoComplete="off"
                      maxLength={50}
                      className={clsx(
                        "form-control form-control-lg form-control-solid"
                      )}
                      value={this.state.new_password}
                      onChange={(event) =>
                        this.setState({ new_password: event.target.value })
                      }
                    />
                  </div>
                  <div
                    className="d-flex align-items-center mb-3"
                    data-kt-password-meter-control="highlight"
                  >
                    <div className="flex-grow-1 bg-gray-200 rounded h-5px me-2"></div>
                    <div className="flex-grow-1 bg-gray-200 rounded h-5px me-2"></div>
                    <div className="flex-grow-1 bg-gray-200 rounded h-5px me-2"></div>
                    <div className="flex-grow-1 bg-gray-200 rounded h-5px"></div>
                  </div>
                </div>
                <div className="text-muted fs-7">
                  At least one uppercase, one lowercase, one number and one
                  special symbol. Minimum 6 characters, maximum 50 characters.
                </div>
              </div>

              <div className="fv-row mb-10">
                <div className="d-flex justify-content-between mt-n5">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Confirm New Password
                    </label>
                  </div>
                </div>
                <input
                  type="password"
                  autoComplete="off"
                  maxLength={50}
                  className={clsx(
                    "form-control form-control-lg form-control-solid"
                  )}
                  value={this.state.confirm_password}
                  onChange={(event) =>
                    this.setState({ confirm_password: event.target.value })
                  }
                />
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary w-100 mb-5"
                  disabled={this.props.inProgress}
                >
                  {!this.props.inProgress && (
                    <span className="indicator-label">
                      Update Password & Continue
                    </span>
                  )}
                  {this.props.inProgress && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForcedPasswordReset);
